export const getSelectedPackage = (detail) => {
  return Object.keys(detail).length > 0 ? detail : null;
};

export const packageTotalPrices = (pkg) => {
  const pkgs = {
    price: 0,
    priceWithDiscount: 0,
    totalDiscount: 0,
    totalExchanged: 0,
    totalDiscountExchanged: 0,
    total: 0,
    discount: 0,
    exchangeRate: 0,
  };

  if (pkg) {
    pkgs.totalExchanged = pkg.price.exchanged;
    pkgs.totalDiscountExchanged = pkg.price.totalExchanged;
    pkgs.totalDiscount = pkg.price.total;
    pkgs.total = pkg.price.price;
    pkgs.discount = pkg.price.discountExchanged;
    pkgs.exchangeRate = pkg.exchangeRate;
  }

  return pkgs;
};
